class CountUp extends HTMLElement {
  constructor() {
    super();

    // don't proceed with the animation if the user has set its preference to reduce motion
    if (window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true) {
      return;
    }

    // start the animation when the counter comes to view
    const observerCallback = (payload) => {
      if (payload[0].isIntersecting) {
        this.initAnimation();
        // stop observing the count up element after the animation is triggered
        this.observer.unobserve(this);
      }
    };
    this.observer = new IntersectionObserver(observerCallback);
    this.observer.observe(this);
  }

  initAnimation() {
    const animationDuration = 2000; // in ms
    // calculate the duration of each frame when updating the animation 40 times per second
    const frameDuration = 1000 / 40;
    // calculate the number of frames needed to complete the animation
    const totalFrames = Math.round(animationDuration / frameDuration);
    // set ease-out-cubic function that slows the count as it progresses
    const easeOutCubic = (t) => --t * t * t + 1;

    // Animation function
    const animateCountUp = (el) => {
      let frame = 0;
      const countTo = parseInt(el.innerHTML, 10);
      const counter = setInterval(() => {
        frame++;
        // calculate the progress as a value between 0 and 1 & Pass that value to the easeOutCubic function to get the progress on a curve
        const progress = easeOutCubic(frame / totalFrames);

        // calculate the current count using the progress value
        const currentCount = Math.round(countTo * progress);

        // update the element on current count change
        if (parseInt(el.innerHTML, 10) !== currentCount) {
          el.innerHTML = currentCount;
        }

        // stop the animation when the last frame is reached
        if (frame === totalFrames) {
          clearInterval(counter);
        }
      }, frameDuration);
    };

    // Run the animation
    animateCountUp(this);
  }
}

if (!customElements.get('count-up')) {
  customElements.define('count-up', CountUp);
}
